import { TabItem, useTabs } from "../../../../commons/tabs/Tabs";
import { AdOrders } from "./adOrders/AdOrders";
import { CampaignOrders } from "./campaignOrders/CampaignOrders";
import { useEffect, useMemo, useState } from "react";
import { getPagination } from "../../../../../utils/pagination";
import { strings } from "../../../../../intl/fa";
import { useIsVip } from "../../../../../hooks/useFeatureScopes";
import { useConfigs } from "hooks/useConfigs";

export enum OrdersTab {
  Ads = "Ads",
  Campaigns = "Campaigns",
}

const tabs: TabItem[] = [
  { name: strings.tabs.campaign_list, id: OrdersTab.Campaigns },
  { name: strings.tabs.ads_list, id: OrdersTab.Ads },
];

export const useOrderTabs = () => {
  const tabsHandler = useTabs(tabs, 0, "OrderTabs");
  const isVip = useIsVip();

  const List = useMemo(() => {
    if (!isVip) return AdOrders;
    else {
      switch (tabsHandler.selectedTab.id) {
        case OrdersTab.Campaigns:
          return CampaignOrders;
        case OrdersTab.Ads:
          return AdOrders;
        default:
          return AdOrders;
      }
    }
  }, [tabsHandler, isVip]);

  return { List, tabsHandler };
};

export const useOrdersListState = (
  loading: boolean,
  ordersList: any[],
  sendRequest: (args: any) => Promise<any>
) => {
  const hasOrders = ordersList.length > 0;
  const [requestSent, setRequestSent] = useState(false);
  const { cool_down_milli_second } = useConfigs();

  useEffect(() => {
    setTimeout(() => {
      sendRequest({
        ...getPagination(1, 50),
        onSuccess: () => setRequestSent(true),
      });
    }, cool_down_milli_second * 2);
  }, []);

  return {
    showEmptyState: !loading && requestSent && ordersList.length === 0,
    showShimmer: loading && !hasOrders,
    showChildren: !loading || hasOrders,
    showDivider: hasOrders,
    showList: hasOrders,
  };
};
